import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Loader from "../Components/Loader"; // 👈 import your loader

const inputStyle = {
  backgroundColor: "#fff",
  border: "1px solid #ddd",
  color: "#000",
  padding: "10px",
  borderRadius: "4px",
  width: "100%",
};

const textareaStyle = { ...inputStyle, minHeight: "100px" };

const Contactform = () => {
  const [loading, setLoading] = useState(false); // loader state
  const [alert, setAlert] = useState(null); // { type: "success" | "danger", message: "" }
  const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <Formik
      initialValues={{ name: "", email: "", subject: "", message: "" }}
      validationSchema={Yup.object({
        name: Yup.string().required("**Name is required"),
        email: Yup.string()
          .email("**Invalid email")
          .required("**Email is required"),
        subject: Yup.string().required("**Subject is required"),
        message: Yup.string().required("**Message is required"),
      })}
      onSubmit={async (values, { resetForm }) => {
        setLoading(true);
        setAlert(null);
        try {
          const res = await axios.post(
           `${API_BASE}/fcontacts`,
            values
          );
          setAlert({
            type: "success",
            message: res.data.message || "Message sent successfully!",
          });
          resetForm();
        } catch (err) {
          setAlert({
            type: "danger",
            message: "Something went wrong. Please try again.",
          });
        } finally {
          setLoading(false);
        }
      }}
    >
      {() => (
        <Form>
          {/* Loader overlay */}
          {loading && <Loader />}

          <div className="row">
            <div className="col-lg-6 mb-3">
              <Field type="text" name="name" placeholder="Name" style={inputStyle} />
              <ErrorMessage
                name="name"
                component="div"
                style={{ color: "red", fontSize: "12px" }}
              />
            </div>
            <div className="col-lg-6 mb-3">
              <Field type="email" name="email" placeholder="Email" style={inputStyle} />
              <ErrorMessage
                name="email"
                component="div"
                style={{ color: "red", fontSize: "12px" }}
              />
            </div>
          </div>

          <div className="mb-3">
            <Field type="text" name="subject" placeholder="Subject" style={inputStyle} />
            <ErrorMessage
              name="subject"
              component="div"
              style={{ color: "red", fontSize: "12px" }}
            />
          </div>

          <div className="mb-3">
            <Field as="textarea" name="message" placeholder="Message" style={textareaStyle} />
            <ErrorMessage
              name="message"
              component="div"
              style={{ color: "red", fontSize: "12px" }}
            />
          </div>

          <button
            type="submit"
            className="btn"
            style={{
              backgroundColor: "#1d2163",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "4px",
            }}
            disabled={loading}
          >
            {loading ? "Sending..." : <>Send Message <i className="fa fa-long-arrow-right ms-3"></i></>}
          </button>

          {/* ✅ Bootstrap Alert */}
          {alert && (
            <div
              className={`alert alert-${alert.type} mt-3`}
              role="alert"
              style={{ fontSize: "14px" }}
            >
              {alert.message}
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default Contactform;
